// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistPricingPage-cls1_5cr","cls2":"CoScientistPricingPage-cls2_0ug CoScientistPricingPage-cls1_5cr"};